import React, { useEffect } from 'react';
import { NotFoundImage } from '../../../assets/images';
import Image from 'next/image';
import { useRouter } from '../../../hooks/useCustomRouter';

declare const window: WindowTypes;

const NotFoundSection = () => {
  const router = useRouter();
  const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;
  const handleGoToHome = () => {
    if (typeof window !== 'undefined') {
      window?.androidApp?.goToHome();
      window?.webkit?.messageHandlers?.iosApp?.postMessage('goToHome');
    }
    window.location.href = PUBLIC_URL;
  };
  useEffect(() => {
    if (sessionStorage.getItem('after_login_redirect') === 'true') {
      sessionStorage.removeItem('after_login_redirect');
      router.replace(PUBLIC_URL);
    }
  }, []);
  return (
    <div className="container flex flex-col justify-center items-center h-screen lg:h-[670px]">
      <Image
        className="h-[200px] w-auto"
        src={NotFoundImage.src}
        alt="not found image"
        width={200}
        height={200}
      />
      <p className="text-reliableBlack text-xl lg:text-2xl font-bold mb-2 mt-[19px] lg:mt-6">
        Halaman Tidak Ditemukan
      </p>
      <p className="text-reliableBlack text-sm lg:text-lg text-center lg:max-w-[767px]">
        Maaf, sepertinya kami tidak dapat menemukan halaman yang kamu cari. Kamu mungkin memasukkan
        alamat yang salah atau halaman yang Kamu cari mungkin telah dipindahkan.
      </p>
      <div className="mb-[30px] mt-6 lg:mb-0 lg:mt-5 w-full lg:w-auto">
        <div
          onClick={handleGoToHome}
          className="py-4 lg:px-6 rounded-[4px] text-center text-base text-reliableBlack font-bold uppercase border border-reliableBlack cursor-pointer"
        >
          Kembali ke beranda
        </div>
      </div>
    </div>
  );
};

export default NotFoundSection;
